import { useEffect, useState } from 'react';
import { FontIcon } from '@fluentui/react';
import {
  CaretDown,
  Faders,
  FlowArrow,
  SquaresFour,
  Users,
  Waveform,
} from '@phosphor-icons/react';

import { LeftMenuGroupContainer } from './styles';
import { useTranslation } from 'react-i18next';

export interface MenuGroup {
  title: string;
  items: MenuItem[];
}

export interface MenuItem {
  title: string;
  iconName: string;
  key: string;
}

interface LeftMenuGroupProps {
  isMenuOpen: boolean;
  group: MenuGroup;
  onLinkClick: (key: string) => void;
  toggleMenu: () => void;
}

export const LeftMenuGroup = ({
  isMenuOpen,
  group,
  onLinkClick,
  toggleMenu,
}: LeftMenuGroupProps) => {
  const [isGroupExpanded, setIsGroupExpanded] = useState(false);
  const { t } = useTranslation('leftmenu');

  const getGroupIcon = (group: string): JSX.Element => {
    switch (group) {
      case 'Voice Solutions':
        return <Waveform />;
      case 'Manage Subscriptions':
        return <Users />;
      case 'Integration and Automation':
        return <FlowArrow />;
      case 'Apps Configuration':
        return <Faders />;
      default:
        return <SquaresFour />;
    }
  };

  const handleGroupClick = () => {
    if (!isMenuOpen) {
      toggleMenu();
    }

    setIsGroupExpanded(!isGroupExpanded);
  };

  useEffect(() => {
    if (!isMenuOpen) {
      setIsGroupExpanded(false);
    }
  }, [isMenuOpen]);

  return (
    <LeftMenuGroupContainer
      isGroupExpanded={isGroupExpanded}
      isMenuOpen={isMenuOpen}
    >
      <div
        className={`group group-${group.title.replace(' ', '-')}`}
        onClick={handleGroupClick}
      >
        {getGroupIcon(group.title)}
        <span>
          {t(`MENU_GROUP_${group.title.replaceAll(' ', '_').toUpperCase()}`)}
          <CaretDown size={16} />
        </span>
      </div>
      <ul className="groupLinks">
        {group?.items &&
          group.items.map((link) => (
            <li key={link.key}>
              <button
                className="menuLink"
                onClick={() =>
                  onLinkClick(
                    link.key.indexOf('empty') >= 0 ? 'empty' : link.key
                  )
                }
              >
                <FontIcon iconName={link.iconName} />
                {t(
                  `MENU_LINK_${link.title.replaceAll(' ', '_').toUpperCase()}`
                )}
              </button>
            </li>
          ))}
      </ul>
    </LeftMenuGroupContainer>
  );
};
